export default from './StatsAcc.jsx';



// WEBPACK FOOTER //
// ./src/pages/stats_acc/index.js